import { DATE_FORMAT } from '@dev-spendesk/grapes';
import { type DateFormatter } from '@dev-spendesk/grapes/dist/hooks/useDateFormatter/useDateFormatter';

import type { TGlobalFunctionTyped } from 'common/hooks/useTranslation';
import { type APITravelStop } from 'modules/requests/models/tripStop';

export const getTripDestination = (route: APITravelStop[]) => {
  if (route.length > 1) {
    const city = route[1].placeName;
    if (route.length > 2) {
      const numberOfExtraStops = route.length - 2;
      return `${city} +${numberOfExtraStops}`;
    }
    return city;
  }
  return null;
};

export const getTripDestinationCountryCode = (route: APITravelStop[]) => {
  if (route.length > 1) {
    return route[1].country?.code;
  }
  return null;
};

export const getTripTitle = (
  route: APITravelStop[],
  t: TGlobalFunctionTyped,
) => {
  const destination = getTripDestination(route);
  if (!destination) {
    return null;
  }
  return t('requests.panel.travelBudget.tripTo', {
    city: destination,
  });
};

export const getTripDates = (
  startDate: Date,
  endDate: Date,
  localeFormat: DateFormatter,
) => {
  return ` ${localeFormat(startDate, DATE_FORMAT.CUSTOM, {
    day: 'numeric',
    month: 'short',
  })} - ${localeFormat(endDate, DATE_FORMAT.CUSTOM, {
    day: 'numeric',
    month: 'short',
  })}`;
};
